export default {"src":"/_next/static/media/carousel-icon-delivery.f87f4924.svg","height":174,"width":202,"blurWidth":0,"blurHeight":0};